import { resolveComponent as _resolveComponent, createVNode as _createVNode, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock } from "vue";
export function render(_ctx, _cache, $props, $setup, $data, $options) {
    const _component_Hero = _resolveComponent("Hero");
    const _component_Realizations = _resolveComponent("Realizations");
    const _component_Brands = _resolveComponent("Brands");
    const _component_Services = _resolveComponent("Services");
    const _component_Portfolio = _resolveComponent("Portfolio");
    const _component_FAQ = _resolveComponent("FAQ");
    return (_openBlock(), _createElementBlock(_Fragment, null, [
        _createVNode(_component_Hero),
        _createVNode(_component_Realizations),
        _createVNode(_component_Brands),
        _createVNode(_component_Services),
        _createVNode(_component_Portfolio),
        _createVNode(_component_FAQ)
    ], 64));
}
